module.exports = __webpack_public_path__ + "img/icon-settings-black.972e79ad.svg";